import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FooterPageComponent } from './footer-page/footer-page.component';
import { RouterModule } from '@angular/router';
import { AuthenticationModule } from '@auth/authentication.module';
import { LoginComponent } from '../../authentication/login/login.component';
import { CookieModule } from 'ngx-cookie';


@NgModule({
    declarations: [FooterPageComponent],
    imports: [
        CommonModule,
        RouterModule,
        AuthenticationModule,
        CookieModule.forChild()
    ],
    exports: [FooterPageComponent]
})
export class FooterModule { }
